exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nil-sa-groups-waitingroom-style__waitingRoom{margin:0 auto;padding:50px;font-size:20px;width:100%;min-height:124px;text-align:center}.nil-sa-groups-waitingroom-style__waitingRoomParam{font-weight:600;color:#cd2600}.nil-sa-groups-waitingroom-style__spinnerContainer{margin-right:10px;display:inline-block!important}.nil-sa-groups-waitingroom-style__waitPosition,.nil-sa-groups-waitingroom-style__waitTime{display:inline}", ""]);

// exports
exports.locals = {
	"waitingRoom": "nil-sa-groups-waitingroom-style__waitingRoom",
	"waitingRoomParam": "nil-sa-groups-waitingroom-style__waitingRoomParam",
	"spinnerContainer": "nil-sa-groups-waitingroom-style__spinnerContainer",
	"waitTime": "nil-sa-groups-waitingroom-style__waitTime",
	"waitPosition": "nil-sa-groups-waitingroom-style__waitPosition"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-2!../node_modules/postcss-loader/lib??ref--2-3!../node_modules/less-loader/dist/cjs.js??ref--2-4!./components/groups/WaitingRoom/style.less
// module id = 253
// module chunks = 0